/*
 * 文件EN: index.vue,
 * 文件CN: 可以自适应高度的textarea,
 * 创建时间: Monday, 15th June 2020 4:58:24 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */
<template>
  <div :style="{height: heights, minHeight:minHeight }">
    <textarea
      ref="textarea"
      class="textarea"
      type="textarea"
      :readonly="readonly"
      :style="{height: heights, minHeight:minHeight }"
      v-model="values"
    ></textarea>
  </div>
</template>

<script>
import calcTextareaHeight from './utils'

export default {
  name: 'common-textarea',
  props: {
    value: [String],
    height: [String, Number],
    readonly: {
      type: Boolean,
      default: false,
      comment: '是否只读',
    },
  },
  computed: {
    values: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  data() {
    return {
      // 动态高度
      heights: '35px',
      minHeight: '35px',
    }
  },
  watch: {
    values(val) {
      this.getHeight()
    },
  },
  created() {
    const { height } = this

    if (height) {
      if (height.__proto__ === Number.prototype) {
        this.heights = `${height}px`
        this.minHeight = `${height}px`
      } else if (height.__proto__ === String.prototype) {
        if (height.indexOf('px') !== -1) {
          this.heights = `${height}`
          this.minHeight = `${height}`
        } else {
          this.heights = `${height}px`
          this.minHeight = `${height}px`
        }
      }
    }
  },
  mounted() {
    // 获取有多少行
    if (!this.values) return
    this.values.split(' ')[0].indexOf(/\n/g)
    const row = this.values.split(/\n/g).length
    this.heights = calcTextareaHeight(this.$refs.textarea, 1, row).height
  },
  methods: {
    getHeight() {
      this.heights = calcTextareaHeight(this.$refs.textarea, 1, null).height
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
